module.exports = __webpack_public_path__ + "img/ico_debito-conta.a23cc5e1.svg";